module.exports = __webpack_public_path__ + "static/media/download-big-icon.0a99105a.svg";